module.exports = __webpack_public_path__ + "static/media/TJ-Address.e8b1b703.svg";